// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__GjnKa","subheader":"ReorderModal_subheader__1X6va","listWrap":"ReorderModal_listWrap__1QZAt"};